<template>
  <transition name="fade">
    <div class="layer-w" v-show="show">
      <div class="layer" @click="hide" @touchmove.prevent></div>
      <transition name="rise600">
        <div class="c-selectForm" v-show="show">
          <div class="c-selectForm__top">
            {{ title }}
            <div class="c-selectForm__close" @click="hide"></div>
          </div>
          <div class="c-selectForm__content">
            <div
              class="c-selectForm__item"
              v-for="(v, index) in list"
              :key="index"
              @click="select(index, v)"
            >
              {{ v.word }}
              <div
                class="c-selectForm__status"
                :class="
                  activeIndex === index ? 'c-selectForm__status--active' : ''
                "
              ></div>
            </div>
          </div>
          <div class="c-selectForm__bottom" v-show="btnShow">
            <div class="c-selectForm__cancel" @click="skip">
              {{ $t('skip') }}
            </div>
            <div
              class="c-selectForm__sure"
              :class="activeIndex !== '' ? 'c-selectForm__sure--active' : ''"
              @click="submit"
            >
              {{ $t('submit') }}
            </div>
          </div>
          <div class="fullscreen__padding"></div>
        </div>
      </transition>
    </div>
  </transition>
</template>
<script>
export default {
  props: {
    show: {
      type: Boolean
    },
    list: {
      type: Array
    },
    title: {
      type: String
    },
    mustSelectOne: {
      type: Boolean,
      default: false
    },
    btnShow: {
      type: Boolean,
      default: false
    }
  },
  mounted() {},
  data() {
    return {
      activeIndex: ''
    };
  },
  methods: {
    hide() {
      this.$emit('hide');
    },
    select(index) {
      if (this.mustSelectOne) {
        this.activeIndex = index;
        this.$emit('select', index);
      } else {
        if (this.activeIndex === index) {
          this.activeIndex = '';
        } else {
          this.activeIndex = index;
        }
      }
    },
    submit() {
      if (this.activeIndex !== '') {
        this.$emit('submit', this.activeIndex);
      }
    },
    skip() {
      this.$emit('submit', '');
    }
  },
  components: {}
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/animate.scss';

.c-selectForm {
  position: fixed;
  bottom: 0;
  left: 0;
  background: #fff;
  width: 100%;
  max-height: 80%;
  overflow-y: auto;
  border-radius: 0.12rem 0.12rem 0px 0px;
}
.c-selectForm__top {
  color: #666;
  border-radius: 0.12rem 0.12rem 0px 0px;
  padding: 0 0.16rem;
  background: #f9f9f9;
  height: 0.56rem;
  line-height: 0.56rem;
  position: relative;
}
.c-selectForm__close {
  top: 0;
  right: 0;
  position: absolute;
  width: 0.44rem;
  height: 100%;
  background: url(~@/assets/image/general_dialog_icon_close@2x.png) no-repeat 0
    center / 0.28rem 0.28rem;
}
.c-selectForm__content {
  padding: 0 0.16rem;
}
.c-selectForm__item {
  font-size: 0.16rem;
  height: 0.56rem;
  line-height: 0.56rem;
  border-bottom: 1px solid rgba(178, 186, 194, 0.15);
  position: relative;
}
.c-selectForm__status {
  font-size: 0.16rem;
  position: absolute;
  right: 0;
  top: 0;
  width: 0.24rem;
  height: 100%;
}
.c-selectForm__status--active {
  background: url(~@/assets/image/general_icon_selected@2x.png) no-repeat right
    center / 0.24rem 0.24rem;
}
.c-selectForm__bottom {
  overflow: hidden;
  padding: 0.08rem 0 0.08rem;
  font-size: 0.18rem;
}
.c-selectForm__cancel {
  float: left;
  width: 0.92rem;
  height: 0.44rem;
  line-height: 0.44rem;
  background: rgba(255, 255, 255, 1);
  border-radius: 0.04rem;
  border: 1px solid rgba(157, 157, 157, 1);
  text-align: center;
  margin: 0 0.2rem 0 0.16rem;
}
.c-selectForm__sure {
  float: left;
  width: 2.31rem;
  height: 0.44rem;
  line-height: 0.44rem;
  background: rgba(13, 203, 184, 0.4);
  border-radius: 6px;
  text-align: center;
  color: #fff;
}
.c-selectForm__sure--active {
  background: #0dcbb8;
}
.layer-w {
  z-index: 20;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.layer {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}
@media (min-width: 414px) {
  .c-selectForm__sure {
    width: 75%;
    float: right;
    margin: 0 2.5%;
  }
  .c-selectForm__cancel {
    width: 15%;
    margin: 0 2.5%;
  }
}
@media (min-width: 768px) {
  .c-selectForm__item {
    height: 56px;
    line-height: 56px;
    font-size: 16px;
  }
  .c-selectForm__top {
    height: 56px;
    line-height: 56px;
    border-radius: 12px 12px 0 0;
  }
  .c-selectForm__sure,
  .c-selectForm__cancel {
    height: 44px;
    line-height: 44px;
    font-size: 18px;
  }
  .c-selectForm__close {
    width: 44px;
    background: url(~@/assets/image/general_dialog_icon_close@2x.png) no-repeat
      0 center / 40px 40px;
  }
}
</style>
